import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import * as signalR from "@microsoft/signalr";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Images } from "../Images";
import toast from 'react-hot-toast';
import { GET_USER_INFO } from '../api/endpoints'
import { call } from "../config/axios";
import {  GET_LIVE_MEETING } from "../config/endpoints";
import "./styles.css";

import { FaMicrophone, FaVideo, FaVideoSlash, FaMicrophoneSlash } from "react-icons/fa";

const Join = ({ id, UserJoinClick }) => {
  const location = useLocation();
  const meetingId = location.pathname.split("/").slice(-1)?.[0];
  const connectionRef = useRef(null);
  const messageId = useRef(crypto.randomUUID());
  const history = useHistory();
  const inputref = useRef(null);
  const [micOn, setMicOn] = useState(true);
  const [camOn, setCamOn] = useState(true);
  const [profileImage, setProfileImage] = useState("");
  const [userProfileData, setuserProfileData] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [liveMeeting, setLiveMeeting] = useState({});
  const [userLocation, setUserLocation] = useState({});
  const [joinAccepted, setJoinAccepted] = useState(false);
  const [joinState, setJoinState] = useState("checking");
  const [meetingStatus, setMeetingStatus] = useState("not-started");
  const isAdminCreated = localStorage.getItem("isAdminMeeting") === "true";
  const first_name = localStorage.getItem("first_name");
  const last_name = localStorage.getItem("last_name");
  const register_id = localStorage.getItem("register_id");

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        setUserLocation({
          ip: data.ip,
          city: data.city,
          region: data.region,
          country: data.country_name,
          latitude: data.latitude,
          longitude: data.longitude,
        });
      } catch (error) {
        console.error("Error fetching IP/location:", error);
      }
    };

    fetchLocation();
  }, []);


  useEffect(() => {
    if (
      joinAccepted &&
      liveMeeting?.p_id &&
      liveMeeting?.meeting_type &&
      liveMeeting?.video_call_type
    ) {
      joinMeeting();
    }
  }, [joinAccepted, liveMeeting]);

  useEffect(() => {
    getLiveMeetingData();
    getUserProfile(register_id);
  }, [register_id]);

  const getLiveMeetingData = async () => {
    const creator_id = isAdminCreated ? localStorage.getItem("register_id") : localStorage.getItem("creator_id");
    return await call(GET_LIVE_MEETING, {
      creator_id: creator_id,
      meeting_id: meetingId,
    })
      .then((res) => {
        setLiveMeeting(res.data?.data?.Items[0]);
      })
      .catch((err) => {
        throw err;
      });
  };

  const sendJoinRequest = async () => {
    const request = {
      MatchId: meetingId,
      MessageId: messageId.current,
      Name: userProfileData?.first_name + " " + userProfileData?.last_name,
      Role: userProfileData?.account_role,
      Email: userProfileData?.email,
      Location: `${userLocation?.country},${userLocation?.city},${userLocation?.region}`,
      Timestamp: new Date().toISOString(),
  };
  
  console.log('userProfileData',userProfileData)
    try {
      console.log("[sendJoinRequest] Sending request:", request);
      await connectionRef.current.invoke("SendJoinRequest", request);
      setJoinState("waiting-for-approval")
        toast("🟡 Join request sent. Please wait for approval.");
    } catch (error) {
        console.error("Failed to send join request:", error);
    }
};


const joinMeeting = () => {
  const live = liveMeeting || {}; 

  const obj = {
    meeting_id: meetingId,
    user_name: inputValue,
    type: "join_meeting",
    user_id: localStorage.getItem("register_id") + 'uplevel',
    creator_id: live.p_id || "",             
    meeting_type: live.meeting_type || "",   
    camera: camOn,
    micro: micOn,
    videoType: live.video_call_type || ""
  };

  console.log("Sending meeting object:", obj); 
  localStorage.setItem("on_going_meeting", JSON.stringify(obj));
  history.push(`/group-call/${meetingId}`);
};

  const handleOpenJoinPopup = async () => {
    sendJoinRequest();
   
  };

  const getUserProfile = async () => {
    await call(GET_USER_INFO, { register_id })
      .then((res) => {
        console.log("getUserProfile", res);
        if (res?.data?.status === 200) {
          setProfileImage(res?.data?.data.profile_image);
          setuserProfileData(res?.data?.data)
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isAdminCreated) return;
  
    const connect = async () => {
      const connection = new signalR.HubConnectionBuilder()
      .withUrl("https://mysqlapi.we2call.com/joinRequestHub", {
        transport: signalR.HttpTransportType.WebSockets
    })
        .configureLogging(signalR.LogLevel.Information)
        .build();

  
  
      connectionRef.current = connection; // Store globally
  
      connection.on("JoinRequestAccepted", (msgId) => {
        if (msgId === messageId.current) {
          setJoinAccepted(true); 
          setJoinState("waiting-for-approval")
          toast.success("✅ You have been accepted into the meeting.");
        }
      });
  
      // Handle rejected join request
      connection.on("JoinRequestRejected", (msgId) => {
        if (msgId === messageId.current) {
          setJoinState("rejected");
          
          toast.error("❌ Your join request was rejected.");
        }
      });
  
      // Handle meeting started event
      connection.on("MeetingStarted", () => {
        setMeetingStatus("started");
        setJoinState((prev) =>
          prev !== "waiting-for-approval" ? "ready-to-request" : prev
        );
        toast("🔔 Meeting has started.");
      });
  
      try {
        if (!meetingId) {
          console.error("meetingId is null or undefined");
          return;
        }
        await connection.start();
        await connection.invoke("JoinGroup", "participant", meetingId, messageId.current);
  
       
        const isStarted = await connection.invoke("IsMeetingStarted", meetingId);
  
        setMeetingStatus(isStarted ? "started" : "not-started");
        setJoinState((prev) =>
          prev !== "waiting-for-approval"
            ? isStarted
              ? "ready-to-request"
              : "meeting-not-started"
            : prev
        );
        
      } catch (err) {
        console.error("SignalR connection error:", err);
      }
    };
  
    connect();
  
    return () => {
      connectionRef.current?.stop();
    };
  }, [meetingId]);
  
  const pollMeetingStatus = async () => {
    if (!connectionRef.current) return;
  
    try {
      const isStarted = await connectionRef.current.invoke("IsMeetingStarted", meetingId);
      setMeetingStatus(isStarted ? "started" : "not-started");
      setJoinState((prev) =>
        prev !== "waiting-for-approval"
          ? isStarted
            ? "ready-to-request"
            : "meeting-not-started"
          : prev
      );
    } catch (err) {
      console.error("Polling failed:", err);
    }
  };

  
  useEffect(() => {
    const interval = setInterval(() => {
      pollMeetingStatus();
    }, 10000); // every 10 seconds
  
    return () => clearInterval(interval);
  }, []);

  return (
    <>
     {joinState === "meeting-not-started" && (
    <div className="waiting-img">
      <img src={Images.callWaiting} alt="Waiting" />
      <p className="text-white">Meeting has not started yet...</p>
    </div>
  )}
    {joinState === "waiting-for-approval" && (
    <div className="waiting-img">
      <img src={Images.callWaiting} alt="Waiting" />
      <p className="text-white">Waiting for joining...</p>
    </div>
  )}
      {joinState === "ready-to-request" && (
      <div className="join-container">
        <div className="img-join">
          <img src={Images.We2callDark} alt="join" />
        </div>
        <div className="join-box">
          {/* <img src={profileImage || Images.DhoniImage} alt="" /> */}
          <img src={localStorage?.getItem("profileImage")} alt="profile_image" />
          <div className="name-box">
            <h3>
              {first_name} {last_name}
            </h3>
            <p>inviting for video call...</p>
          </div>
          <div className="cam-micro">
            <p>
              {liveMeeting?.video_call_type === "audio-video" ? <>{camOn ? <></> : <span>Camera is Off...</span>}</> : <></>}

              {micOn ? <></> : <span>Microphone is Off...</span>}
            </p>
          </div>
          <div className="mic-cam-icon">
            {liveMeeting?.video_call_type === "audio-video" ? (
              <>
                <div className={`box-mic ${camOn ? "box-green" : "box-red"}`} onClick={() => setCamOn(!camOn)}>
                  {camOn ? <FaVideo /> : <FaVideoSlash />}
                </div>
              </>
            ) : (
              <></>
            )}

            <div className={`box-mic ${micOn ? "box-green" : "box-red"}`} onClick={() => setMicOn(!micOn)}>
              {micOn ? <FaMicrophone /> : <FaMicrophoneSlash />}
            </div>
          </div>
          <div className="input-but">
            <input type="text" ref={inputref} onChange={(e) => setInputValue(e.target.value)} placeholder="Enter your name" />
            <button className="btn btn-join" disabled={inputValue === ""} onClick={() => handleOpenJoinPopup()}>
              Join
            </button>
          </div>
        </div>
      </div>
      )}
      {joinState === "rejected" && (
    <div className="waiting-img">
      <img src={Images.callWaiting} alt="Rejected" />
      <p className="text-white">❌ You were not allowed to join this meeting.</p>
    </div>
  )}
    </>
  );
};

export default Join;
